// extracted by mini-css-extract-plugin
module.exports = {"GoodsCard":"index_GoodsCard__12LK-","cover":"index_cover__3LOfA","coverImg":"index_coverImg__1YIxq","info":"index_info__k2gYl","line":"index_line__2oU8A"};